import { AppError } from './base-errors';

export class DocumentError extends AppError {
  constructor(message: string) {
    super(message);
    this.name = 'DocumentError';
    Object.setPrototypeOf(this, DocumentError.prototype);
  }
}

export class AuthenticationError extends DocumentError {
  constructor(message: string = 'Dokumentet kan ikke vises, prøv at logge ind') {
    super(message);
    this.name = 'AuthenticationError';
    Object.setPrototypeOf(this, AuthenticationError.prototype);
  }
}

export class AccessDeniedError extends DocumentError {
  constructor(message: string = 'Du har ikke adgang til dokumentet') {
    super(message);
    this.name = 'AccessDeniedError';
    Object.setPrototypeOf(this, AccessDeniedError.prototype);
  }
}

export class DocumentStatusError extends DocumentError {
  status: string;

  constructor(status: string, message?: string) {
    super(message || `Dette dokument kan ikke åbnes, fordi det har følgende status: ${status}`);
    this.status = status;
    this.name = 'DocumentStatusError';
    Object.setPrototypeOf(this, DocumentStatusError.prototype);
  }
}

export class DocumentLibraryError extends DocumentError {
  constructor(message: string = 'Dette dokument er tilknyttet et dokumentbibliotek, som ikke er tilgængeligt, og kan derfor ikke åbnes.') {
    super(message);
    this.name = 'DocumentLibraryError';
    Object.setPrototypeOf(this, DocumentLibraryError.prototype);
  }
}

export class DocumentNotFoundGeneralMessage extends DocumentError {
  constructor(message: string = 'Dokumentet kan være inaktivt, arkiveret eller du har ikke adgang til det.') {
    super(message);
    this.name = 'DocumentNotFoundGeneralMessage';
    Object.setPrototypeOf(this, DocumentLibraryError.prototype);
  }
}
